
import { STIScanFailed } from "@/domain/entities/STI";
import { prop, Vue } from "vue-class-component";
import XLSX from "xlsx";

export class Props {
  data = prop<STIScanFailed[]>({
    default: () => [],
    required: true,
    type: Array
  });
}

export default class ScanFailedCard extends Vue.with(Props) {
  XLSX = XLSX;
  downloadExcel() {
    const data = this.XLSX.utils.json_to_sheet(
      this.data.map((d) => ({
        [this.$t("sti.nomorStt") as string]: d.sttOrBag,
        [this.$t("sti.reasonFailed") as string]: this.$t(d.errorMessage)
      }))
    );
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, data, this.$t("sti.sttFailedScan"));
    this.XLSX.writeFile(wb, this.$t("sti.sttFailedScan") + ".xlsx");
  }
}
